import { Component, HostBinding, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface FwConfirmDialogData {
  title?: string,
  content?: string,
  html?: string,
}

/**
 * @deprecated Legacy Vision: Please upgrade to the newer FwDialogConfirmComponent
 */
@Component({
  selector: 'fw-dialog-confirm-dialog',
  template: `
      <h1 mat-dialog-title *ngIf="title">{{ title }}</h1>
      <div mat-dialog-content *ngIf="html" class="markup" [innerHTML]="html | trusthtml"></div>
      <div mat-dialog-content *ngIf="!html">{{ content || ('confirmDialog.body' | translate) }}</div>
      <div mat-dialog-actions align="center">
          <button test-id="no-button" mat-stroked-button
                  [mat-dialog-close]="false">{{ 'confirmDialog.no' | translate }}
          </button>
          <button test-id="yes-button" mat-flat-button color="primary"
                  [mat-dialog-close]="true">{{ 'confirmDialog.yes' | translate }}
          </button>
      </div>
  `,
  styles: [`
    [mat-dialog-content] {
      text-align: center;
    }

    [mat-dialog-content].markup {
      text-align: inherit;
    }
  `],
})
export class FwLegacyConfirmDialogComponent {
  @HostBinding('attr.class') class = 'mat-dialog-component';
  @HostBinding('attr.test-id') 'test-id' = 'confirm-dialog';
  title = this.data.title;
  content = this.data.content;
  html = this.data.html;

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: FwConfirmDialogData,
  ) {
  }
}
